/**
 * Tiny DOM construction helper used by the UI screens.
 *
 *   el('button', 'seg-btn', 'Fly')  →  <button class="seg-btn">Fly</button>
 */
export function el(tag, className, text) {
  const node = document.createElement(tag);
  if (className) node.className = className;
  if (text != null) node.textContent = text;
  return node;
}
